import React from 'react';
import { Image, Text, Box } from '@chakra-ui/react';

const FileViewer = ({ fileUrl, fileType }) => {
  if (!fileUrl || fileType === 'null') {
    return <Text color='red.500' fontStyle='italic'>File surat belum diupload</Text>;
  }

  const fileExt = fileType.toLowerCase();

  if (['png', 'jpg', 'jpeg', 'gif'].includes(fileExt)) {
    return (
      <Image
        src={fileUrl}
        alt="File Gambar"
        borderRadius="8"
        maxH="600px"
        mx="auto"
        mt={4}
      />
    );
  }

  if (['pdf', 'doc', 'docx'].includes(fileExt)) {
    return (
      <Box mt={4}>
        <iframe
          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
          width="100%"
          height="600px"
          style={{ borderRadius: '8px' }}
          title="File Viewer"
        />
      </Box>
    );
  }

  return <Text color='red.500'>Format file tidak didukung</Text>;
};

export default FileViewer;
